import pkg from '../package.json';
import TagManager from './tag-manager';

export const VERSION     = pkg.version;
export const NAMESPACE   = TagManager.NAMESPACE;
export const PROPERTY_ID = TagManager.PROPERTY_ID;
export const ready       = TagManager.ready;
export const set         = TagManager.set;
export const get         = TagManager.get;
export const getNSO      = TagManager.getNSO;
export const track       = TagManager.track;
export const dump        = TagManager.dump;
export const update      = TagManager.update;

window.__VOONTO__.when('voonto:ready').then(() => {
  const app = Voonto.getInstance();

  app.on('vtm:track', function(event, data) {
    data = typeof data === 'string' ? JSON.parse(data) : data;
    set(data);
    track();
  });

  app.on('vtm:set', function(event, data) {
    data = typeof data === 'string' ? JSON.parse(data) : data;
    set(data);
  });

//  app.on('paywall:content', function() {
//    const provider = window.__VOONTO__.lookup('vocento.__PROVIDER__.paywall');
//
//    if (!!provider.isNewAnonymousSession) {
//      app.one('paywall:update', (config) => {
//        set(_getPaywallData(config));
//        track();
//      });
//    } else {
//      set(_getPaywallData(provider));
//      track();
//    }
//  });
});

/* Private */

//function _getPaywallData(source) {
//  return {
//    IDEvolok:              source.pid,
//    productoEvolok:        source.meter,
//    nPaginasConsumidas:    source.count,
//    nPaginasPermitidas:    source.max,
//    autorizacionContenido: source.result,
//    idCookieEvolok:        source.cookie
//  };
//}



// WEBPACK FOOTER //
// ./src/index.js